import {Injectable} from '@angular/core';
import {HttpInterceptor, HttpEvent, HttpHandler, HttpRequest, HttpResponse, HttpErrorResponse, HttpHeaders} from '@angular/common/http';
import {LoginService} from '../login/login.service';
import {Observable, throwError} from 'rxjs';
import {catchError, finalize, tap} from 'rxjs/operators';
import {ParametrosConst} from 'src/app/util/parametrosConst';

@Injectable({
  providedIn: 'root'
})
export class ResponseInterceptorService implements HttpInterceptor {
  constructor(private _loginService: LoginService) {
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // const ok: string;
    return next.handle(request).pipe(
      tap(
        event => {
          if (event instanceof HttpResponse) {
            let statusCode = '';
            let message = '';
            if (event.body instanceof Array &&
              event.body.length > 0 &&
              typeof event.body[0].status_code !== 'undefined') {
              statusCode = event.body[0].status_code;
              message = event.body[0].message;
            } else if (event.body instanceof Object &&
              event.body.status_code !== 'undefined') {
              statusCode = event.body.status_code;
              message = event.body.message;
            }
            if (statusCode != null && `${statusCode}` !== '200' && statusCode !== '') {
              const error = new HttpErrorResponse({
                error: event.body,
                headers: request.headers,
                // tslint:disable-next-line:radix
                status: Number.parseInt(statusCode),
                statusText: message,
                url: request.url || undefined,
              });
              throw error;
            } else if (event.status === 200 && event.body != null
              && (typeof event.body.authorization === 'string'
                || typeof event.body.Authorization === 'string')) {
              localStorage.setItem(ParametrosConst.TOKEN,
                typeof event.body.authorization === 'undefined' ? event.body.Authorization : event.body.authorization
              );
            }
          }
        }), catchError(err => {
        let error;
        let reload = false;
        if (err.error != null && err.error instanceof Object && err.error.message != null) {
          error = err.error.message;
        } else if (err.error != null && err.error instanceof Array) {
          error = err.error[0].message;
        } else {
          error = err.message;
        }

        if (err.status === 401 || err.status === 403) {
// auto logout if 401 response returned from api
          this._loginService.logout();
          reload = true;
          if (error === 'Forbidden' || error === 'Access Denied' || err.status === 403) {
            error = 'Su sesión ha expirado, ingrese nuevamente.';
          }
        } else if (err.status === 200) {
          error = 'Ocurrió un error en el servidor.';
        } else if (err.status === 0) {
          error = 'No se pudo concretar la consulta al servicio';
        }
        if (error.indexOf('ingrese nuevamente') > -1 || reload) {
          this._loginService.logout();
          setTimeout(() => {
            location.reload();
          }, ParametrosConst.TIEMPO_RELOAD);
        }
        return throwError(error);
      }), finalize(() => {
      }));
  }
}
